module.exports = __webpack_public_path__ + "img/mj8-october.9331d2b1.png";